/**
 * Created by Joseph.Saliba on 2/3/16.
 */
import { IService } from './IService';

export class Factory {
  public static Create(t: { new(...args): IService }): IService {
    return function(this: any, ...args: any[]) { return new (Function.bind.apply(t, [t, ...args]) as any)(); };
  }
}

namespace app.services {
  export class Factory {
    public static Create(t: { new(...args): IService }): IService {
      return function(this: any, ...args: any[]) { return new (Function.bind.apply(t, [t, ...args]) as any)(); };
    }
  }
}
